import React from 'react';
import { colors } from '../theme';

export default function LoadingSpinner({ size = 48, style = {} }) {
  const borderWidth = Math.max(2, Math.floor(size / 8));
  return (
    <div
      className="spinner"
      style={{
        width: size,
        height: size,
        border: `${borderWidth}px solid currentColor`,
        borderTopColor: 'transparent',
        color: colors.accent,
        ...style,
      }}
    />
  );
}
